<div class="screen-title">Edit supplier contact</div>

<contact-edit [model]="model | async" (onSave)="saveContact($event)" (onCancel)="cancel()"></contact-edit>
